import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Machines from "./pages/Machines";
import MachineDetail from "./pages/MachineDetail";
import Services from "./pages/Services";
import Realizations from "./pages/Realizations";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Occasions from "./pages/Occasions";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import MachineForm from "./pages/MachineForm";
import UsedMachineForm from "./pages/UsedMachineForm";
import RentalMachineForm from "./pages/RentalMachineForm";
import TestimonialForm from "./pages/TestimonialForm";
import RealizationForm from "./pages/RealizationForm";
import BlogForm from "./pages/BlogForm";
import Location from "./pages/Location";
import { initGA, logPageView } from "./utils/analytics";
import { SiteSettingsProvider } from "./contexts/SiteSettingsContext";

// Component to track page views
function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search, document.title);
  }, [location]);
}

function AppContent() {
  usePageTracking();

  return (
    <Routes>
      {/* Admin routes (without Navbar/Footer) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/machines/new" element={<MachineForm />} />
      <Route path="/admin/machines/edit/:slug" element={<MachineForm />} />
      <Route path="/admin/occasions/new" element={<UsedMachineForm />} />
      <Route path="/admin/occasions/edit/:id" element={<UsedMachineForm />} />
      <Route path="/admin/location/new" element={<RentalMachineForm />} />
      <Route path="/admin/location/edit/:id" element={<RentalMachineForm />} />
      <Route path="/admin/testimonials/new" element={<TestimonialForm />} />
      <Route path="/admin/testimonials/edit/:id" element={<TestimonialForm />} />
      <Route path="/admin/realizations/new" element={<RealizationForm />} />
      <Route path="/admin/realizations/edit/:id" element={<RealizationForm />} />
      <Route path="/admin/blog/new" element={<BlogForm />} />
      <Route path="/admin/blog/edit/:id" element={<BlogForm />} />
      
      {/* Public routes (with Navbar/Footer) */}
      <Route path="/*" element={
        <>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/machines" element={<Machines />} />
            <Route path="/machines/:slug" element={<MachineDetail />} />
            <Route path="/occasions" element={<Occasions />} />
            <Route path="/location" element={<Location />} />
            <Route path="/services" element={<Services />} />
            <Route path="/realisations" element={<Realizations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </>
      } />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <SiteSettingsProvider>
        <div className="App">
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </div>
      </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
